export const SENDING_REQUEST = 'PERMISSIONGROUPSLIST_SENDING_REQUEST';
export const GETALL_SUCCESS = 'PERMISSIONGROUPSLIST_GETALL_SUCCESS';
export const GETALL_FAILURE = 'PERMISSIONGROUPSLIST_GETALL_FAILURE';